import React from "react";
import { Navigate } from "react-router-dom";

/**
 * ProtectedRoute component that checks user role before allowing access to a route
 * @param {Object} props
 * @param {React.ReactNode} props.children - The component to render if user has access
 * @param {string[]} props.allowedRoles - Array of role names that are allowed to access this route
 * @returns {React.ReactNode} - Either the children component or a redirect to landing page
 */
const ProtectedRoute = ({ children, allowedRoles }) => {
  // Get user details from sessionStorage
  const userDetailsStr = sessionStorage.getItem("userDetails");
  
  if (!userDetailsStr) {
    // No user details found, redirect to login
    return <Navigate to="/" replace />;
  }

  try {
    const userDetails = JSON.parse(userDetailsStr);
    const userType = userDetails?.userType;

    // Check if user's role is in the allowed roles list
    if (!userType || !allowedRoles.includes(userType)) {
      // User doesn't have required role, redirect to landing page
      return <Navigate to="/" replace />;
    }

    // User has required role, render the protected component
    return children;
  } catch (error) {
    console.error("Error parsing user details:", error);
    // Error parsing user details, redirect to login
    return <Navigate to="/" replace />;
  }
};

export default ProtectedRoute;
